import {
  AppBar,
  Toolbar,
  Container,
  Box,
  Button,
  IconButton,
  Typography,
} from "@mui/material";
import { useState } from "react";
import companyName from "../../assets/images/vr-Logo.png";
import HeaderContactDetails from "./HeaderContactDetails";
import Navigation from "../navigation/Navigation";
import PopupDialog from "../common/PopupDialog";
import ContactForm from "../contactForm/ContactForm";

export default function Header() {
  const [openQuote, setOpenQuote] = useState(false);
  return (
    <div>
      <HeaderContactDetails />

      <AppBar position="static" color="inherit" elevation={1}>
        <Container>
          <Toolbar
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              py: 1.5,
            }}
          >
            {/* Logo Section */}
            <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
              <img
                src={companyName}
                alt="Vishnu Construction Company"
                style={{ height: 50 }}
              />
              <Box sx={{ display: "flex", flexDirection: "column" }}>
                {/* <Typography
                  variant="h5"
                  sx={{
                    fontFamily: '"Playfair Display", serif',
                    fontWeight: 700,
                    color: "#b19033",
                    lineHeight: 1,
                    letterSpacing: "0.5px",
                  }}
                >
                  VR
                </Typography> */}
                <Typography
                  variant="body2"
                  sx={{
                    fontWeight: 700,
                    color: "#1f2937",
                    letterSpacing: "1.6px",
                    fontSize: "1rem",
                    textTransform: "uppercase",
                    fontFamily: "'Playfair Display', serif",
                  }}
                >
                  Builders & Promoters
                </Typography>
                <Typography
                  variant="caption"
                  sx={{
                    color: "#b19033",
                    // fontStyle: "italic",
                    fontWeight: 500,
                    letterSpacing: "0.5px",
                    lineHeight: 1,
                    mt: 0.5,
                  }}
                >
                  Building Trust, Shaping Futures
                </Typography>
              </Box>
            </Box>

            {/* Desktop Navigation */}
            <Box sx={{ display: { xs: "none", md: "block" } }}>
              <Navigation />
            </Box>

            {/* Quote Button (Desktop only) */}
            <Button
              variant="contained"
              sx={{
                display: { xs: "none", md: "block" },
                bgcolor: "black",
                borderRadius: "10px",
                px: 4,
                py: 1,
                "&:hover": { bgcolor: "#333" },
              }}
              onClick={() => setOpenQuote(true)}
            >
              REQUEST QUOTE
            </Button>

            {/* Mobile Menu Icon */}
            <IconButton sx={{ display: { xs: "block", md: "none" } }}>
              <Navigation mobileMenu />
            </IconButton>
          </Toolbar>
        </Container>
      </AppBar>
      <PopupDialog
        open={openQuote}
        title="Request a Quote"
        onClose={() => setOpenQuote(false)}
        maxWidth="md"
      >
        <ContactForm
          title="Tell us about your project"
          subtitle="We’ll get back to you shortly with details"
          buttonText="Submit"
          onSubmit={() => setOpenQuote(false)}
        />
      </PopupDialog>
    </div>
  );
}
